/**
 * Tenant-related utility functions
 */

import { getTenantIdByOperator } from "../stores/tenantStore";
import { alertMessage } from "./alert";

/**
 * Validates if the selected operator has a valid tenant ID
 * @param operator - The operator (role_key) to validate
 * @returns boolean - true if valid, false otherwise (also shows alert if invalid)
 */
export const validateTenantId = (operator: string): boolean => {
	const tenantId = getTenantIdByOperator(operator);
	if (!tenantId) {
		alertMessage(
			"error",
			`The selected operator "${operator}" does not have a valid tenant ID. Please contact admin.`
		);
		return false;
	}
	return true;
};
